'use client'

import {
  shouldTrackOncePerSessionDay,
  useAbTest,
  useTrackAbTest,
} from '@marketplace-web/feature-flags/ab-tests-data'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { SessionTrackWebVitals } from '@marketplace-web/layout/legacy-layout-feature'
import { useSession } from '@marketplace-web/shared/session-data'

const TrackOptimizedLoadingMetrics = () => {
  const isOptimizedLoadingEnabled = useFeatureSwitch('web_homepage_optimized_loading')
  const abTest = useAbTest('web_homepage_optimized_loading')
  const isLoggedIn = !!useSession().user

  useTrackAbTest(abTest, shouldTrackOncePerSessionDay)

  if (!isOptimizedLoadingEnabled || !abTest) return null

  return (
    <SessionTrackWebVitals
      prefix="home_"
      labels={{ optimized_loading: abTest.variant, user: isLoggedIn ? 'logged_in' : 'anon' }}
      disableSystemTimingEvent
    />
  )
}

export default TrackOptimizedLoadingMetrics
